import uuid from 'uuid';
import { isEmpty, isString, isArray } from 'lodash';

// `createEmptyOptionCollection`:
//    length - integer
//    [text] - (optional) - array or string
// Accept collection length and array of strings (or one string).
// Return array of objects e.g. ( { id: uuid(), value: text[0] }
// @sinslav

export default (length, text = []) =>
  Array.from({ length }, (item, index) => {
    const objToCreate = { id: uuid() };

    if (isString(text)) {
      objToCreate.value = `${text} ${index + 1}`;
    }
    if (isArray(text) && !isEmpty(text)) {
      objToCreate.value = text[index] || text[0];
    }

    return objToCreate;
  });
